import React, { useEffect, useRef, useState } from 'react'
import Layout from '../../../components/layout/Layout'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { sendData } from '../../../store/actions'
import * as Icon from 'ubs-icons'
import Validator from 'simple-react-validator'
import { useForceUpdate } from '../../common/useForceUpdate'
import { checkLowercase, checkMinLength, checkNumeric, checkSpecialCharacter, checkUppercase, isMobileDevice } from '../../../common/functions'
import useSocket from '../../common/useSocket'
import AppHeader from '../../common/components/app-header'
import UInput from '../../../common/component/UInput'
import UPopup from '../../../common/component/UPopup'
import Commonrightcircle from '../../../common/component/RightCircle/commonrightcircle'
import CommonInvite from '../../../common/component/CommonInvite/CommonInvite'
import { COLOR, REGEX } from '../../../common/constant'
import {withRouter} from "../../../common/hocs/routing-hoc";

function ResetPassword() {
    let location = useLocation()
    const dispatch = useDispatch()
    const history = useHistory()
    const [success, setSuccess] = useState(false)
    const _FRU = useSelector(e => e?.common?.forgotRecoveryUser)
    const [errorMsg, setErrorMsg] = useState('')
    const [disabledBtn, setDisabledBtn] = useState(false)

    const { code } = useParams()
    const [resetDetail, setResetDetail] = useState({
        password: '',
        cpassword: '',
        code: code,
    })
    const [passwordEye, setPasswordEye] = useState(false)
    const [hide, setHide] = useState(false)
    const forceUpdate = useForceUpdate()
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: { forceUpdate },
        validators: {
            uppercase: {  // name the rule
                message: 'Please use uppercase.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.upperCase) && params.indexOf(val) === -1
                },
            },
            lowercase: {  // name the rule
                message: 'Please use lowercase.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.lowerCase) && params.indexOf(val) === -1
                },
            },
            specialcase: {  // name the rule
                message: 'Please use one special character.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.specialChar) && params.indexOf(val) === -1
                },
            },
            number: {  // name the rule
                message: 'Please use one number.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.number) && params.indexOf(val) === -1
                },
            },
        },
    }))

    const { on, off, refresh } = useSocket(res => {
        setDisabledBtn(false)
        if (!res.error) {
            switch (res.event) {
                case 'resetPassword':
                    setSuccess(true)
                    setTimeout(() => {
                        history.push('/login')
                    }, 5000)
                    break
                default:
                    return true
            }
        } else {
            setErrorMsg(res.data.error)
            setTimeout(() => setErrorMsg(res.data.error), 5000)
        }
    })

    const inputEvent = (e) => {
        let { name, value } = e.target
        value = value.replace(/^\s+/g, '').trim()
        setResetDetail((val) => {
            return { ...val, [name]: value }
        })
    }

    useEffect(() => {
        const data = { code: location.pathname.split('/')[2] }
        if(location.pathname.split('/')[2]) sendData(dispatch, 'getResetCodeInfo', data)
        else {
            if(!_FRU) {
                history.push('/login')
            }
        }
        on()
        return () => off()
    }, [])

    const onSubmit = obj => {
        if (validator?.current?.allValid()) {
            if (resetDetail?.cpassword !== resetDetail?.password) {
                setErrorMsg('Password and confirm password does not match')
            } else {
                setDisabledBtn(true)
                const data = resetDetail
                if (location.pathname?.includes('reset-with-recovery')) {
                    data.user = _FRU
                    delete data?.code
                }
                sendData(dispatch, 'resetPassword', data)
            }
        } else {
            validator?.current?.showMessages()
        }
    }

    const onKeyUp = (e) => {
        if (e.key === 'Enter') {
            onSubmit(e)
        }
    }

    return (
        <React.Fragment>
            <Layout module="emailsent">
                {!success && <React.Fragment>
                    <div className="u_account-form">
                        <Commonrightcircle/>
                        <AppHeader header="Reset Password"
                                   title="To create your new password, provide the following information, and then click change password button."/>
                        <UInput className="u_mb-20" label="New Password" password asterisk
                                hasError={validator?.current?.message('password', resetDetail?.password, 'required|min:8|uppercase|lowercase|specialcase|number')}>
                            <input onChange={inputEvent} value={resetDetail.password} name="password" onKeyUp={onKeyUp} type={`${passwordEye ? 'text' : 'password'}`}
                                   autoComplete="off" placeholder=" "/>
                            <div className="u_input-note u_ib">
                                <UPopup params={{ className: 'u_tooltip u_tooltip-full', disabled: isMobileDevice() }}
                                        desc={<span>{!passwordEye ? 'Show Password' : 'Hide Password'} </span>}>
                                <span className="u_rollover u_cp u_flex"
                                      onClick={() => setPasswordEye(!passwordEye)}>{!passwordEye ?
                                    <Icon.HideEye size={18} fill={COLOR.u_icon_bg}/> :
                                    <Icon.Eye size={18} fill={COLOR.u_icon_bg}/>}</span>
                                </UPopup></div>
                        </UInput>
                        <UInput className="u_mb-20" label="Confirm Password" password asterisk
                                hasError={validator?.current?.message('ConfirmPassword', resetDetail?.cpassword, 'required|min:8|uppercase|lowercase|specialcase|number')}>
                            <input onChange={inputEvent} value={resetDetail?.cpassword} name="cpassword"
                                   onKeyUp={onKeyUp} type={`${hide ? 'text' : 'password'}`}
                                   autoComplete="off" placeholder=" "/>
                            <div className="u_input-note u_ib">
                                <UPopup params={{ className: 'u_tooltip u_tooltip-full', disabled: isMobileDevice() }}
                                        desc={<span>{!hide ? 'Show Password' : 'Hide Password'} </span>}>

                                <span className="u_rollover u_cp u_flex" onClick={() => setHide(!hide)}>{!hide ?
                                    <Icon.HideEye size={18} fill={COLOR.u_icon_bg}/> :
                                    <Icon.Eye size={18} fill={COLOR.u_icon_bg}/>}</span>
                                </UPopup>
                            </div>
                        </UInput>

                        <div className={`u_reset-content ${errorMsg ? 'u_mb-0' : 'u_mb-10'}`}>
                            <ul className="u_flex u_flex-wrap">
                                <li style={{ color: `${checkMinLength(resetDetail.password, 8) ? '#60B158' : '#8F95A6'}` }}>
                                    <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                     fill={`${checkMinLength(resetDetail.password, 8) ? '#60B158' : '#8F95A6'} `}/>Minimum
                                    8 Characters
                                </li>
                                <li style={{ color: `${checkUppercase(resetDetail.password) ? '#60B158' : '#8F95A6'} ` }}>
                                    <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                     fill={`${checkUppercase(resetDetail.password) ? '#60B158' : '#8F95A6'} `}/>Uppercase
                                </li>
                                <li style={{ color: `${checkLowercase(resetDetail.password) ? '#60B158' : '#8F95A6'} ` }}>
                                    <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                     fill={`${checkLowercase(resetDetail.password) ? '#60B158' : '#8F95A6'} `}/>Lowercase
                                </li>
                                <li style={{ color: `${checkNumeric(resetDetail.password) ? '#60B158' : '#8F95A6'} ` }}>
                                    <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                     fill={`${checkNumeric(resetDetail.password) ? '#60B158' : '#8F95A6'} `}/>1
                                    Numeric Number
                                </li>
                                <li style={{ color: `${checkSpecialCharacter(resetDetail.password) ? '#60B158' : '#8F95A6'} ` }}>
                                    <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                     fill={`${checkSpecialCharacter(resetDetail.password) ? '#60B158' : '#8F95A6'} `}/>1
                                    Special Character
                                </li>
                            </ul>
                        </div>
                        {errorMsg.length !== 0 && <p className="u_error-message u_mb-10">{errorMsg}</p>}

                        <div className="u_flex u_content-between">
                            <button disabled={disabledBtn} type="button" onClick={() => history.push('/login')}
                                    className="u_btn u_btn__white u_w-full u_cp">Cancel
                            </button>
                            <button disabled={disabledBtn} type="button" onClick={onSubmit}
                                    className="u_btn u_btn__blue u_w-full u_cp">Change Password
                            </button>
                        </div>
                    </div>
                </React.Fragment>}
                {
                    success &&
                    <div className="u_account-form">
                        <div className="u_sendmail-section u_t-center u_mt-50">
                            <span className="u_sendmail-icon u_ib u_relative">
                                <img className="u_tnkuRound" src="../images/images/u-tnkuRound.png" alt="Round"/>
                                <img className="u_emailIcon" src="../images/images/greenLargeIcon.png" alt="greenLargeIcon"/>
                                <img className="u_tnkuLine" src="../images/images/u-tnkuLine.png" alt="Line"/>
                            </span>
                        </div>
                        <CommonInvite heading="Password Reset" title="Your password has been successfully reset."/>
                        <button disabled={disabledBtn} type="button" onClick={() => history.push('/login')}
                                className="u_account-btn u_w-full u_cp">Sign In
                        </button>
                    </div>
                }
            </Layout>
        </React.Fragment>
    )
}


export default withRouter(ResetPassword)

